<template>
    <div v-if="item" class="product-modal" @click="closeModal()">
        <div class="product-modal__container" @click.stop>
            <div class="product-modal__content">
                <div class="product__info">
                    <div class="product-modal__upper-close-btn">
                        <button @click="closeModal()">
                            <img src="@/assets/images/decoration/cross-shop.svg">
                        </button>
                    </div>
                    <h2 class="shop__heading product__heading" v-text="item.title"></h2>
                    <image-carousel :images="galleryImages" :altText="item.title"/>
                    <div class="product__info__grouped-text">
                        <div class="product__info__price__container">
                            <h3 v-if="showOfferPrice" class="product__info__price__container__text" :class="{'showOfferPrice': showOfferPrice}" v-text="`${currency}${item.old_price}`"></h3>
                            <h3 class="product__info__price__container__text offer" v-text="displayPrice"></h3>
                        </div>
                        <multiselect
                                class="product__info__quantity shop__multiselect"
                                v-model="quantity"
                                openDirection="below"
                                :searchable="false"
                                :allow-empty="false"
                                :show-labels="false"
                                :options="options"/>
                    </div>
                    <h3 v-text="$t('SHOP_PRODUCT_FREE_DELIVERY')"></h3>
                    <p v-if="item.stock < 20" v-text="$t('SHOP_PRODUCT_LOW_STOCK')"></p>
                    <div>
                        <button class="product__info__button product__info__button__green"
                            v-text="$t('SHOP_PRODUCT_ADD')"
                            @click="addToNextDelivery"></button>
                    </div>
                    <text-dropdown :expand="true" :heading="$t('SHOP_PRODUCT_DESCRIPTION')">
                        <div class="product__info__accordion-content">
                            <p class="shop__paragraph mt-0 mb-6">{{item.description}}</p>
                            <div v-if="item.attributes.materials" class="product__info__specifications">
                                <p class="product__info__specifications-header" v-text="`${$t('SHOP_PRODUCT_MATERIALS')}:`"></p>
                                <p class="shop__paragraph m-0">{{item.attributes.materials}}</p>
                            </div>
                            <div v-if="item.attributes.dimensions" class="product__info__specifications">
                                <p class="product__info__specifications-header" v-text="`${$t('SHOP_PRODUCT_DIMENSIONS')}:`"></p>
                                <p class="shop__paragraph m-0">{{item.attributes.dimensions}}</p>
                            </div>
                        </div>
                    </text-dropdown>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Multiselect from 'vue-multiselect';
import countriesJson from '@/resources/countries.json';
import TextDropdown from './TextDropdown.vue';
import ImageCarousel from '@/components/partials/account/shop/product-details/ImageCarousel';

export default {
    name: 'ProductModal',
    components: { ImageCarousel, Multiselect, TextDropdown },
    data() {
        return {
            quantity: 1,
            window: {
                width: 0,
                mobileBreakpoint: 768,
            },
        };
    },
    props: {
        item: {
            required: true,
            type: Object,
        },
    },
    computed: {
        options() {
            const quantityOptions = Array.from({ length: 5 }, (_, i) => i + 1);
            return quantityOptions;
        },
        currency() {
            const country = countriesJson.find(country => country.currency.code === this.item.currency);
            return country.currency.symbol;
        },
        displayPrice() {
            const indexOfDecimalPoint = this.item?.price.indexOf('.');
            const price = indexOfDecimalPoint > 0 ? this.item.price.slice(0, indexOfDecimalPoint) : this.item.price;
            return `${this.currency}${price}`;
        },
        showOfferPrice() {
            return Number(this.item.old_price) > 0;
        },
        galleryImages() {
            return this.item.images.gallery;
        },
        thumbnail() {
            return this.item.images.main.thumbnail;
        },
        isMobile() {
            return this.window.width < this.window.mobileBreakpoint;
        },
    },
    mounted() {
        window.addEventListener('resize', this.handleResize);
        this.handleResize();
    },
    methods: {
        addToNextDelivery() {
            this.$emit('addProduct', Object.assign(this.item, { quantity: this.quantity }));
        },
        closeModal() {
            this.$emit('close');
        },
        handleResize() {
            this.window.width = window.innerWidth;
        },
    },
};
</script>

<style scoped lang="scss">
.product-modal {
    background: rgba(1, 1, 1, 0.5);
    display: flex;
    justify-content: flex-end;
    align-items: center;
    position: fixed;
    top: 60px;
    z-index: 98;
    width: 100vw;
    height: 100%;

    &__container {
        background-repeat: repeat;
        background-position: center;
        background-size: 200%;
        background-image: url('~@/assets/images/decoration/bg–paper.jpg');
        width: 540px;
        height: 100%;
    }

    &__upper-close-btn {
        display: flex;
        justify-content: flex-end;

        button {
            width: 25px;
        }
    }

    &__content {
        padding: 20px;
        height: calc(100% - 60px);
        overflow-y: scroll;

        .product__info {
            width: unset;
            padding-top: 40px;
        }
    }
}
</style>
